import { FC, memo } from "react";
import { LinearProgress, RecordContextProvider, useListContext } from "react-admin";
import ErrorIcon from "@mui/icons-material/Error";
import * as React from "react";
import { Tooltip, Typography } from "@mui/material";

export interface CommaSeparatedFieldListProps {
  children: React.ReactElement;
  newLines?: boolean;
  maxItems?: number;
}

export const CommaSeparatedFieldList: FC<CommaSeparatedFieldListProps> = memo((props) => {
  const { children, newLines, maxItems } = props;
  const { isLoading, error, data } = useListContext(props);

  if (error) {
    return <ErrorIcon role="presentation" color="error" fontSize="small" />;
  }

  if (isLoading || !Array.isArray(data)) {
    return <LinearProgress />;
  }

  const lastIndex = data.length - 1;
  let displayedData = data;
  let rest: any = null;
  if (typeof maxItems === "number" && data.length > maxItems) {
    displayedData = data.slice(0, maxItems);
    const hiddenData = data.slice(maxItems);
    const lastIndex = hiddenData.length - 1;
    rest = (
      <Tooltip
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
        }}
        title={
          <div
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
            }}
          >
            {hiddenData.map((record, index) => (
              <RecordContextProvider value={record} key={record.id || `index:${index}`}>
                {children}
                {index < lastIndex ? ", " : null}
                {index < lastIndex && newLines ? <br /> : null}
              </RecordContextProvider>
            ))}
          </div>
        }
      >
        <Typography component="span" variant="body2" className="whitespace-nowrap">
          {hiddenData.length === 1 ? "1 weiterer" : `${hiddenData.length} weitere`}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <div style={rest ? { whiteSpace: "nowrap" } : {}}>
      {displayedData.map((record, index) => (
        <RecordContextProvider value={record} key={record.id || `index:${index}`}>
          {children}
          {index < lastIndex ? ", " : null}
          {index < lastIndex && newLines ? <br /> : null}
        </RecordContextProvider>
      ))}
      {rest}
    </div>
  );
});
